/**
 * Story engine configuration
 * Builds StoryEngine config from story.json
 */

import type { StoryEngineConfig } from '../../features/story-engine/types'
import type storyData from '../../config/story.json'

type StoryData = typeof storyData

/**
 * Build StoryEngine configuration from story data
 * @param storyData - Story data from story.json
 * @returns StoryEngine configuration
 */
export function buildStoryEngineConfig(storyData: StoryData): StoryEngineConfig {
  const config = storyData.config || {}

  return {
    bubble: config.bubble || { parallaxVerticalDistance: 5 },
    chapterTitle: {
      margin: config.chapterTitle?.margin || 50,
      scrollDistance: (config.chapterTitle as any)?.scrollDistance || 1,
      stickAt: (config.chapterTitle as any)?.stickAt || 50,
    },
    homework: config.homework || { margin: 50 },
    scrollSpeed: config.scrollSpeed || {
      base: 1,
      baseMobile: 0.7,
      inScene: 0.7,
      inSceneMobile: 0.5,
      fromTop: 80,
      fromBottom: 80,
    },
    choices: config.choices || { fadeDuration: 0.4, expandDuration: 0.5 },
  }
}
